const SkeletonContactForm = () => {
  return (
    <div
      className="skeletonFormContact"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="skeletonFormRow">
        <div className="skeleton-input"></div>
        <div className="skeleton-input"></div>
        <div className="skeleton-input"></div>
        <div className="skeleton-input"></div>
        <div className="skeleton-input"></div>
        <div className="skeleton-input"></div>
        <div className="skeleton-input"></div>
        <div className="skeleton-input"></div>
        <div className="skeleton-input"></div>
      </div>

      <div
        className="skeletonFormRow flex"
        style={{
          display: 'flex',
          alignItems: 'center',
          height: '48px',
          marginBottom: '16px',
          justifyContent: 'normal',
          marginTop: '-10px',
        }}
      >
        <div
          className="skeleton-checkbox"
          style={{
            width: '24px',
            height: '24px',
            borderRadius: '50%',
            marginRight: '12px',
            marginBottom: '0px',
          }}
        />
        <div className="skeletonBox">
          <div
            className="skeleton-text"
            style={{
              width: '100%',
              height: '18px',
              marginBottom: '0px !important',
            }}
          />
          <div
            className="skeleton-text"
            style={{
              width: '100%',
              height: '18px',
              marginBottom: '0px !important',
              marginTop: '3px',
            }}
          />
          <div
            className="skeleton-text"
            style={{
              width: '100%',
              height: '18px',
              marginBottom: '0px !important',
              marginTop: '3px',
            }}
          />
        </div>
      </div>

      <div className="skeletonBox recatpchaBox">
        <div
          className="skeleton-text"
          style={{
            width: '100%',
            height: '18px',
            maxWidth: '90%',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        />
        <div
          className="skeleton-text"
          style={{
            width: '100%',
            height: '18px',
            maxWidth: '89%',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        />
        <div
          className="skeleton-text"
          style={{
            width: '100%',
            height: '18px',
            maxWidth: '83%',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        />
        <div
          className="skeleton-text"
          style={{
            width: '100%',
            height: '18px',
            maxWidth: '94%',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        />
        <div
          className="skeleton-text"
          style={{
            width: '100%',
            height: '18px',
            maxWidth: '60%',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        />
      </div>
      <div className="skeleton-button"></div>
    </div>
  );
};

export default SkeletonContactForm;
